<div class="color-picker-component">
  <div class="color-picker-component-header fb-lbl d-flex justify-content-between">
    <div class="d-flex justify-content-between formula-field-wrapper">
      <span class="ouput-formula">{{ currentParsedFormula }}</span>
      <span
        class="clear ml-2 cursor-pointer"
        *ngIf="currentParsedFormula"
        (click)="clearValue(currentNode.name)"
        (keyup.enter)="clearValue(currentNode.name)"
        tabindex="0"
        aria-label="Clear Value"
      >
        <i class="fa fa-exclamation-triangle warning-icon" *ngIf="currentErrorStatus === 'warning'" (mouseenter)="toggleWarningPopup()" (mouseleave)="toggleWarningPopup()"></i>
        <i class="fa fa-exclamation-circle error-icon-1" *ngIf="currentErrorStatus === 'error'" (mouseenter)="toggleWarningPopup()" (mouseleave)="toggleWarningPopup()"></i>
        <i class="pi pi-times"></i
      ></span>
    </div>

    <p-button
      icon="pi pi-pencil"
      styleClass="p-button-rounded p-button-text"
      (click)="openFbuilder()"
      *ngIf="!disableField"
    ></p-button>
    <!-- <span class="icon-properties-container f-icon" >
      <img src="assets\images\svg\icon_color_picker.svg" alt="color picker">
    </span> -->
  </div>
</div>
<div class="warning-wrapper">
  <div class="val-err"  [ngClass]="{
      'error-popup':currentErrorStatus === 'error',
      'warning-popup': currentErrorStatus === 'warning'
    }" *ngIf="showPopup && errorMsg">
    <div class="warning-header">
      <p>Warning</p>
      <i class="pi pi-times"></i>
    </div>
    {{ errorMsg }}
  </div>
</div>
<p-dialog
  header="Formula Builder"
  [modal]="true"
  [(visible)]="showFbuilder"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  styleClass="fb-model"
  [closable]="false"
>
  <div class="row mt-2 mb-3">
    <div class="col-12 mr-0">
      <div>
        <label for="formulaEditorContainer">Expression</label>
      </div>
      <div class="expression-wrapper">
        <div class="expression-section">
          <form [formGroup]="expressionForm">
            <div id="formulaEditorContainer" class="form-control formula-editor">
              <span *ngFor="let formula of formulaArray">
                <span *ngIf="formula.type === 'field'" class="o"
                  >{{ fieldIdMap[formula.fieldId] }}
                  <i
                    class="fa fa-times"
                    (click)="removeItem($event, formula)"
                    (keyup.enter)="removeItem($event, formula)"
                    tabindex="0"
                    aria-label="Remove item"
                  ></i
                ></span>
                <span *ngIf="formula.type === 'operator' || formula.type === 'number'" class="o"
                  >{{ formula.fieldId }}
                  <i
                    class="fa fa-times"
                    (click)="removeItem($event, formula)"
                    (keyup.enter)="removeItem($event, formula)"
                    tabindex="1"
                    aria-label="Remove item"
                  ></i
                ></span>
              </span>
            </div>

            <small *ngIf="errorMsg" class="input-error-text">
              <span [innerHtml]="errorMsg"></span>
            </small>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-2 mb-3">
    <div class="col-12 mr-0 pr-0 operator-wrapper">
      <div class="operator-section">
        <p-button
          icon=""
          label="("
          styleClass="operator para"
          (click)="handleOperatorClick($event, { label: '(' })"
          tooltipPosition="top"
          pTooltip="Press to add '('"
        ></p-button>
        <p-button
          icon=""
          label=")"
          styleClass="operator para"
          (click)="handleOperatorClick($event, { label: ')' })"
          tooltipPosition="top"
          pTooltip="Press to add ')'"
        ></p-button>
        <p-button
          icon="fa fa-plus"
          styleClass="operator"
          (click)="handleOperatorClick($event, { label: '+' })"
          tooltipPosition="top"
          pTooltip="Press to add '+' operator"
        ></p-button>
        <p-button
          icon="fa fa-minus"
          styleClass="operator"
          (click)="handleOperatorClick($event, { label: '-' })"
          tooltipPosition="top"
          pTooltip="Press to add '-' operator"
        ></p-button>
        <p-button
          icon="fa fa-xmark"
          styleClass="operator"
          (click)="handleOperatorClick($event, { label: '*' })"
          tooltipPosition="top"
          pTooltip="Press to add 'X' operator"
        ></p-button>
        <p-button
          icon="fa fa-divide"
          styleClass="operator"
          (click)="handleOperatorClick($event, { label: '/' })"
          tooltipPosition="top"
          pTooltip="Press to add '/' operator"
        ></p-button>
        <p-select
          #fieldMenu
          appendTo="body"
          placeholder="Select Field"
          filterPlaceholder="Select a Field"
          [options]="allFields"
          [(ngModel)]="selectedField"
          optionLabel="name"
          [filter]="true"
          filterBy="name"
          (onChange)="handleFieldSelection($event)"
        >
        </p-select>
        <!--
         <p-button #fieldMenuBtn label="Select Field" icon="pi pi-angle-down" iconPos="right" styleClass="operator field" (click)="fieldMenu.show($event)" tooltipPosition="top" pTooltip="Press to add 'Fields'"></p-button>  
       -->

        <input
          class="num-ip form-control form-control-sm"
          placeholder="Enter Number"
          type="text"
          [(ngModel)]="numberFld"
          (keypress)="isNumberKey($event)"
          (blur)="handleNumberIp($event)"
        />

        <div class="divider"></div>
        <p-button
          icon="fa fa-trash"
          label="Clear Expression"
          styleClass="operator delete"
          (click)="deleteAll()"
        ></p-button>
      </div>
    </div>
  </div>

  <p-accordion value="0">
    <p-accordion-panel value="0">
      <p-accordion-header>Validate expression with sample values</p-accordion-header>
      <p-accordion-content>
        <div class="expression-evaluate-wrapper">
          <form [formGroup]="formulaForm">
            <div class="form-flds">
              <div class="fields">
                <div class="row ml-1 mr-1 mt-2 mb-2">
                  <div class="col-md-6" *ngFor="let field of selectedFields">
                    <div class="row form-group m-0">
                      <label
                        class="col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8"
                        [attr.for]="'field-input-' + field.fieldId"
                        >{{ fieldIdMap[field.fieldId] }}</label
                      >
                      <input
                        type="number"
                        placeholder="Enter Number"
                        [formControlName]="field.formControlName"
                        min="1"
                        (keypress)="isNumberKey($event)"
                        class="form-control col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 form-control-sm"
                        [id]="'field-input-' + field.fieldId"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!--<div class="row form-group">
                <label class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">Output</label>
                <label class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 result" [ngClass]="{'error-text': testOutput && testOutput == 'Invalid Expression','success-text' : testOutput && testOutput != 'Invalid Expression'}">{{testOutput}}</label>
              </div>-->
            </div>
            <div class="result-section-wrapper row">
              <span class="button-group text-left col-6">
                <button type="button" class="btn btn-sm btn-secondary ml-1" (click)="clearForm()">Clear</button>
                <button type="button" class="btn btn-sm btn-secondary ml-2" (click)="test()">Test</button>
              </span>
              <span class="col-6 mt-2">
                <span
                  >Output:
                  <span
                    [ngClass]="{
                      'error-text': testOutput && testOutput === 'Invalid Expression',
                      'success-text': testOutput && testOutput !== 'Invalid Expression'
                    }"
                    >{{ testOutput }}</span
                  ></span
                >
                <span></span>
              </span>
            </div>
          </form>
        </div>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
  <ng-template #footer>
    <div class="button-group text-right">
      <button type="button" class="btn btn-primary cancel-btn" (click)="closeDialog($event)">
        {{ 'CANCEL' | translate }}
      </button>
      <button type="button" class="btn btn-sm btn-primary" (click)="saveFormula($event)">Save</button>
    </div>
  </ng-template>
</p-dialog>
